export function Footer() {
  return (
    <footer className="bg-dark text-white py-8 mt-auto">
      <div className="max-w-full xl:max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Jonathan Space</h3>
            <p className="text-gray-300 text-sm">
              Advanced satellite imagery management and cataloging platform.
              Designed for professionals and enthusiasts.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="text-gray-300 hover:text-primary transition-colors">
                  Jonathan Space Website
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary transition-colors">
                  Documentation
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-primary transition-colors">
                  API Reference
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Contact</h3>
            <p className="text-gray-300 text-sm">
              For support and inquiries, contact Jonathan Space support.
            </p>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-sm text-gray-400">
          <p>&copy; {new Date().getFullYear()} Jonathan Space. Demo Platform.</p>
        </div>
      </div>
    </footer>
  );
}
